import { render } from "./MatchmakerResults.vue?vue&type=template&id=07636823"
import script from "./MatchmakerResults.vue?vue&type=script&lang=js"
export * from "./MatchmakerResults.vue?vue&type=script&lang=js"

import "./MatchmakerResults.vue?vue&type=style&index=0&id=07636823&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__